import { render, staticRenderFns } from "./SubmitVecdynSubassay.vue?vue&type=template&id=cb2c5444&scoped=true&"
import script from "./SubmitVecdynSubassay.vue?vue&type=script&lang=js&"
export * from "./SubmitVecdynSubassay.vue?vue&type=script&lang=js&"
import style0 from "./SubmitVecdynSubassay.vue?vue&type=style&index=0&id=cb2c5444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2c5444",
  null
  
)

export default component.exports